export enum CodeSubPage {
  IndexPage = 'code-code'
}

export enum BlockSubPage {
  IndexPage = 'block-block'
}

export enum SmartContractsSubPage {
  CodePage = 'smart-contracts-code'
}

export enum AssetSubPage {
  SmartContractsPage = 'assets-smart-contracts'
}

export enum AccountBalancesSubPage {
  IndexPage = 'account-account-index',
  Cw20Page = 'account-account-index-cw20'
}

export enum TransactionSubPage {
  IndexPage = 'transaction-transaction',
  EventLogsPage = 'transaction-transaction-event-logs'
}

export enum QueryAndExecuteSubPage {
  IndexPage = 'contract-contract-action',
  ExecutePage = 'contract-contract-action-execute'
}

export enum MarketsSubPage {
  TradingRulesPage = 'markets-trading-rules',
  FundingRateHistoryPage = 'markets-funding-rate-history',
  RealtimeFundingRateSubPage = 'markets-realtime-funding-rate'
}

export enum TradeHistorySubPage {
  SpotPage = 'trade-history-spot',
  DerivativesPage = 'trade-history-derivatives',
  SpotDetailsPage = 'trade-history-spot-tradeId',
  DerivativesDetailsPage = 'trade-history-derivatives-tradeId'
}

export enum ContractSubPage {
  IndexPage = 'contract-contract',
  InitMsgPage = 'contract-contract-init',
  ActionPage = 'contract-contract-action',
  BalancePage = 'contract-contract-balances',
  CW20BalancePage = 'contract-contract-cw20balances',
  TokenHoldersPage = 'contract-contract-token-holders'
}

export enum AccountSubPage {
  IndexPage = 'account-account-index',
  StakingPage = 'account-account-staking',
  TransactionsPage = 'account-account-transactions',
  StakingUnstakePage = 'account-account-staking-unstake',
  StakingRestakePage = 'account-account-staking-restake'
}

export enum Pages {
  Code = 'code',
  Index = 'index',
  Blocks = 'blocks',
  Assets = 'assets',
  Markets = 'markets',
  AssetDetail = 'asset-denom',
  Maintenance = 'maintenance',
  Transactions = 'transactions',
  MarketDetail = 'market-market',
  TradeHistory = 'trade-history',
  Account = 'account-account-index',
  SmartContracts = 'smart-contracts',
  CommunitySpendPool = 'community-spend-pool',
  TransactionEventLogs = 'transaction-transaction-event-logs'
}
